import React from 'react';
import { PaginationCustomStyled } from './styled';
import cx from 'classnames';
import ReactPaginate from 'react-paginate';

export const PaginationCustom = ({
  theme_standard_pagination,
  currentPageData,
  totalPages,
  data,
  _handlePageClick,
}) => {
  const customClass = cx({
    theme_standard_pagination: theme_standard_pagination,
  });

  return (
    <PaginationCustomStyled>
      <div className={customClass}>
        <ReactPaginate
          initialPage={currentPageData}
          previousLabel={'previous'}
          nextLabel={'next'}
          breakLabel={'...'}
          breakClassName={'break-me'}
          // pageCount={this.state.pageCount}
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={_handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
        />
      </div>
    </PaginationCustomStyled>
  );
};
